import React, { ReactElement, useState } from "react";
import { RiArrowDownSLine } from "react-icons/ri";
import { NavLink } from "react-router-dom";

interface ListItem {
  link: string;
  name: string;
  image?: string;
}

interface AccordionApplicationProps {
  list?: ListItem[];
  image?: string;
  name: string;
  className?: string;
  doctora?: boolean;
  master?: boolean;
  level?: boolean;
  book?: boolean;
  search?: boolean;
  Conferences?: boolean;
  experience?: boolean;
  title?: string;
  name_university?: string;
  name_collage?: string;
  Specialization?: string;
  Graduation?: string;
  rate?: string;
  degree?: string;
  children?: ReactElement<any, any> | null;
  type?:string
  text?:string
}

const AccordionApplication: React.FC<AccordionApplicationProps> = ({
  list,
  image,
  name,
  text,
  className,
  doctora,
  master,
  level,
  type,
  book,
  search,
  Conferences,
  experience,
  title,
  name_university,
  name_collage,
  Specialization,
  Graduation,
  rate,
  degree,
  children,
}) => {
  const [accordionOpen, setAccordionOpen] = useState(false);

  return (
    <>
      <div className="">
        <button
          onClick={() => setAccordionOpen(!accordionOpen)}
          className={`flex justify-between items-center w-[80%] bg-[#D9D9D9] gap-3 p-[15px] text-sm py-2 rounded-r-full  hover:bg-[#D9D9D9] text-black transition-all ${className} ${
            accordionOpen ? "bg-[#D9D9D9]  mb-2" : ""
          }`}
        >
          <div className="flex items-center gap-2 px-[15px]">
            <span className={`text-black font-bold`}>{name}</span>
          </div>
          {
            <RiArrowDownSLine
              size={20}
              className={`${
                accordionOpen
                  ? "rotate-180 transition-all"
                  : "rotate-0 transition-all"
              }`}
            />
          }
        </button>
        <div
          className={`grid overflow-hidden w-[90%] mr-5 transition-all duration-300 ease-in-out text-[#25272b] text-sm ${
            accordionOpen
              ? "grid-rows-[1fr] opacity-100"
              : "grid-rows-[0fr] opacity-0"
          }`}
        >
          <div className="overflow-hidden px-1 border-r-2 space-y-1">
            {list &&
              list.map((e, i) => (
                <li className="" key={i}>
                  <NavLink
                    to={e.link}
                    className="flex items-center gap-3 p-[10px] text-sm py-2 rounded-r-full hover:bg-white text-black"
                  >
                    {/* <img src={e.image} alt={e.name} className="w-[20px] h-[20px]" /> */}
                    <p>{e.name}</p>
                  </NavLink>
                </li>
              ))}

            {/* ------------------------------------------ */}
            {/* Information Application Page */}

            {doctora && (
              <>
                {/* <div> عنوان الاطروحة : 
                <span>{title}</span>
              </div> */}
                <div>
                  {" "}
                  اسم الجامعة :<span>{name_university}</span>
                </div>

                <div>
                  {" "}
                  اسم الكلية :<span>{name_collage}</span>
                </div>
                <div>
                  التخصص :<span> {Specialization} </span>
                </div>

                <div>
                  {" "}
                  عام التخرج :<span>{Graduation}</span>{" "}
                </div>

                <div>
                  {" "}
                  المعدل :<span>{rate}%</span>
                </div>

                <div>
                  {" "}
                  الدرجة :<span> {degree} </span>
                </div>
              </>
            )}

            {book && (
              <>
                <div>
                  {" "}
                 <span > {type} </span> <span className="font-bold"> :  {text}</span>
                </div>
              </>
            )}

            {search && (
              <>
                <div className=" text-Secondary text-lg font-bold ">
                  الابحاث العلمية :
                </div>
                <div> بحث علمي حول الذكاء الاصطناعي</div>
                <div> بحث علمي حول ادارة المشاريع </div>
              </>
            )}
            {Conferences && (
              <>
                <div className=" text-Secondary text-lg font-bold ">
                  المؤتمرات :
                </div>
                <div> </div>
                <div> </div>
              </>
            )}
            {experience && (
              <>
                <div className=" text-Secondary text-lg font-bold ">
                  الخبرة التدريسية :
                </div>
                <div> خبرة سنتين في تدريس مادة البرمجة </div>
                <div> خبرة سنتين في تدريس مادة الذكاء الاصطناعي </div>
              </>
            )}
          </div>
          {children}
        </div>
      </div>
    </>
  );
};

export default AccordionApplication;
